import { Tooltip } from '@/components/tooltip/Tooltip';
import { ProcessedTechnology as Technology } from '@/lib/api/technologies';
import { styled } from '@linaria/react';
import * as motion from "motion/react-client";
import Image from 'next/image';
import { joinJSX } from '../../../utils/joinJSX';
import "./TechnologyPill.linaria.module.css!=!./TechnologyPill?./TechnologyPill.linaria.module.css?css=H4sIAAAAAAAAA+0Zy5KqOHTfX5HNrZIZkiKItg2b/odZzTLCQdJCwk1QsCn/fSogii+cvrenx65yQ8l5JIfzPsfXDCLO0ChXEIPSWEG0CiHCmSy4FD4SErcoECFYNUlolIzDcFrjEuZLXmAmeMYa2jVTI4zjVLICp1LmOFqpBmOjqbZQuJrzEM/hnYMaOWRCbeQQ6pqnNzXPF2qh/hmKiUhmWMaxhsJG2CHT8bO2EBcxF7wA1JD9lbE0xZ1YwZ2J02mpUExo3sh1BIqlyhAlM30mj41cMraR09xEny3kaHsuK6wTFsnSyDc5Y/I8G1Hy0nzKuHm0bCxcLpRciQjRizwecTse7BCvuSzoiXzvom63r51Wl7CJFctAXzJH7fyoz9Tffl3KCvh7hF3i5ZUV4Ey+36LQwwSDyO3kliQ3Bbklx5AYnRTUuRuFbF8flvumlnsiSTWrqrdF/ch2X5LtnkieqsRjdcR1nrLNXslcpFwAnssquIKKU+jhMt2H99n65N0R5gVHXEHYqCmU6SoTjfdcxlyh7/qGlC8E5gVk2g9BFKD2KKPNBr1HdHccQW+ckLNweXbAEXBH/LbSBY83OJSiAFF06CvgjAucAF8khU/J80RBFuQsirhY+A6ZgHEat4HOpYpAYcUivtK+O8mr4OAmvoMc5JJpXiG1mLOROzF+tX+ELA1HDpmhP9HIIS76Y9eJ7M4EweYpRDailmVZQZnwArDOWQi+kKViebBguW/amUYSuQYVp7L0Ex5FIB5NyVeFKacbKefz4ixQL0XoWWiexuRRMH7X8DlKJjpRXCx953CBgAUr+Bp8Jzim2D6RkmZazzZRvQs/18uroORRkex1aIJzd2GHMeXvHNyH7MNjzTWfp9Ba7u1nWTK3voQsqBJrtUz+A7Oe5Ewly0sJ1oAvUX6pbzT5BsMaRLo58ZBj1BU/OSIaRJpkRppM1hrPND/GDoLm3s8Ni+tYigKXrVdMHSdo3jV/B9+EuWEMZSqVz0UCihe/44QqyyfJjH6i6c3XufkXRfbHv/iJaPocKfFW1X21znpqTXQ6aubnHzaaOj+sSwVG5izkxQY5xNUImIZgENl0H12Z7dmTTvcxT034dyTmdwFV0S+vtCuuTlMGHBuRsWUbjHeOmbWY2ZWCTDwr2O41QWK6jnJeivpYAcYxbTQxKtg+vX5ws1LQhGkhKz8xOQcNbVqEFBCcvP67on5WvsaH6uXN2q2GKV/EGf9iuWw5f6FiGsYr9f3epd6eG+9kIjoYyz1vVS6unnb7pZP1Eu4uCj7/xLsYJx9ufE9uvJszH0b5/6QejMrdVLjKchzBQgHYCFM3r6yhQB1kuhK7AzwfpT8Zgr3PGIGb2t1wUCevEEYjM1kPsQzdSds7pzfG7utb531Ofawt73dtebpwfhjtOxitbap1qAAEYiJCo4xVuJ0I0ItD86rXSteHzRxVkCHimqGl3Y1Nzc9DxRvqt/f/HPq7BHHIDNf+XrSC3+Pebp/+AfK4MvyaHQAA"
const Hover1 = /*#__PURE__*/styled('div')({
  name: "Hover1",
  class: "h1dh3cc6",
  propsAsIs: false
});
const Hover2 = /*#__PURE__*/styled('div')({
  name: "Hover2",
  class: "hx8xxjg",
  propsAsIs: false
});
const PillContent = /*#__PURE__*/styled('div')({
  name: "PillContent",
  class: "plrh4a",
  propsAsIs: false
});
const IconContainer = /*#__PURE__*/styled('div')({
  name: "IconContainer",
  class: "i1yoobbt",
  propsAsIs: false
});
const Wordmark = /*#__PURE__*/styled('img')({
  name: "Wordmark",
  class: "w1mss8yd",
  propsAsIs: false
});
const _exp4 = /*#__PURE__*/() => Image;
const Icon = /*#__PURE__*/styled(_exp4())({
  name: "Icon",
  class: "i1jqwwa2",
  propsAsIs: true
});
const TopContainer = /*#__PURE__*/styled('div')({
  name: "TopContainer",
  class: "t1rnvrkh",
  propsAsIs: false
});
const Name = /*#__PURE__*/styled('span')({
  name: "Name",
  class: "n1p4qyaf",
  propsAsIs: false
});
const Rating = /*#__PURE__*/styled('div')({
  name: "Rating",
  class: "rmp5h81",
  propsAsIs: false
});
const filledStarClass = "f1vdpiwn";
const Star = /*#__PURE__*/styled('span')({
  name: "Star",
  class: "s17drnjx",
  propsAsIs: false
});
const _exp6 = /*#__PURE__*/() => motion.div;
const TechnologyPillContainer = /*#__PURE__*/styled(_exp6())({
  name: "TechnologyPillContainer",
  class: "t1hasnox",
  propsAsIs: true
});
interface TechnologyPillProps {
  readonly technology: Technology;
  readonly extraClassName?: string | undefined;
  readonly extraProps?: Omit<React.ComponentPropsWithRef<typeof motion.div>, 'className' | 'layout'>;
}
interface TechnologyPillRawProps {
  readonly noBorder?: boolean;
  readonly backgroundColor: string;
  readonly iconNode?: React.ReactNode;
  readonly nameNode?: React.ReactNode;
  readonly wordmarkNode?: React.ReactNode;
  readonly starsNode?: React.ReactNode;
  readonly bumpIntensity?: number;
  readonly extraClassName?: string | undefined;
  readonly extraProps?: Omit<React.ComponentPropsWithRef<typeof motion.div>, 'className' | 'layout'>;
}
export function TechnologyPillRaw({
  extraProps,
  extraClassName,
  noBorder,
  backgroundColor,
  iconNode,
  nameNode,
  wordmarkNode,
  starsNode,
  bumpIntensity: bumpPixels
}: TechnologyPillRawProps) {
  return <TechnologyPillContainer {...extraProps} layout transition={{
    duration: 0.8,
    bounce: 0.5,
    type: 'spring'
  }} className={extraClassName}>
		<Hover1 suppressHydrationWarning style={{
      // @ts-ignore -- this is a custom CSS property for animation
      '--float-random-offset': `-${4 * Math.log(Math.random() * 20)}s`,
      '--float-loop-duration': `${2 + Math.abs(Math.log2(Math.random() * 4))}s`
    }}>
			<Hover2>
				<PillContent style={{
          backgroundColor,
          // @ts-ignore -- this is a custom CSS property for controlling the faux border
          '--border-enabled': noBorder ? '0' : '1',
          // @ts-ignore -- this is a custom CSS property for controlling the intensity of the bump effect
          '--bump-degree': typeof bumpPixels === 'number' ? `-${Math.abs(bumpPixels)}px` : undefined
        }}>
					<TopContainer>
						{iconNode ? <IconContainer>{iconNode}</IconContainer> : null}
						{nameNode ? <Name>{nameNode}</Name> : null}
						{wordmarkNode ? <IconContainer>{wordmarkNode}</IconContainer> : null}
					</TopContainer>
					{starsNode ? <Rating> {starsNode} </Rating> : null}
				</PillContent>
			</Hover2>
		</Hover1>
	</TechnologyPillContainer>;
}
export function TechnologyPill({
  technology,
  ...otherProps
}: TechnologyPillProps) {
  const stars = <>{Array.from({
      length: 5
    }, (_, i) => <Star key={i} className={i < technology.familiarity ? filledStarClass : undefined}>
		★
	</Star>, [technology.familiarity])}</>;
  return <Tooltip tooltipContents={joinJSX(<br />, technology.description.split('\n'))} role='tooltip'>
		<TechnologyPillRaw {...otherProps} noBorder={technology.noBorder ?? false} backgroundColor={technology.backgroundColor} iconNode={'iconUrl' in technology.mark && technology.mark.iconUrl ? <Icon src={technology.mark.iconUrl} alt={`${technology.name} icon`} width={24} height={24} /> : null} nameNode={'textColor' in technology.mark && !('wordmarkUrl' in technology.mark) ? <Name style={{
      color: technology.mark.textColor,
      ...(technology.mark.extraTextStyle ?? {})
    }}>{technology.name}</Name> : null} wordmarkNode={'wordmarkUrl' in technology.mark && technology.mark.wordmarkUrl ? <Wordmark src={technology.mark.wordmarkUrl} alt={`${technology.name} wordmark`} height={24} /> : null} starsNode={stars} />
	</Tooltip>;
}